<template>
  <div class="grid grid-cols-2 gap-4">
    <div>
      <label
        for="month-select"
        class="block mb-1.5 text-sm font-medium text-gray-900"
        >Måned</label
      >
      <select
        id="month-select"
        v-model="selectedMonthLocal"
        name="month"
        class="bg-neutral-50 border border-neutral-300 border-solid text-neutral-900 text-sm rounded-lg focus:ring-neutral-500 focus:border-neutral-500 block w-full p-2.5"
      >
        <option
          v-for="(month, index) in monthNames"
          :key="index"
          :value="index"
        >
          {{ month }}
        </option>
      </select>
    </div>
    <div>
      <label
        for="year-select"
        class="block mb-1.5 text-sm font-medium text-gray-900"
        >Årstal</label
      >
      <select
        id="year-select"
        v-model="selectedYearLocal"
        name="year"
        class="bg-neutral-50 border border-neutral-300 border-solid text-neutral-900 text-sm rounded-lg focus:ring-neutral-500 focus:border-neutral-500 block w-full p-2.5"
      >
        <option v-for="year in yearRange" :key="year" :value="year">
          {{ year }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, defineEmits, defineProps } from "vue";

const props = defineProps({
  selectedMonth: {
    type: Number,
    required: true,
  },
  selectedYear: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["update:selectedMonth", "update:selectedYear"]);

const selectedMonthLocal = ref(props.selectedMonth);
const selectedYearLocal = ref(props.selectedYear);

const monthNames = [
  "Januar",
  "Februar",
  "Marts",
  "April",
  "Maj",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "December",
];

const yearRange = computed(() => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 26 }, (_, i) => currentYear - 4 + i);
});

watch(selectedMonthLocal, (newValue) => {
  emit("update:selectedMonth", newValue);
});

watch(selectedYearLocal, (newValue) => {
  emit("update:selectedYear", newValue);
});

watch(
  () => props.selectedMonth,
  (newValue) => {
    selectedMonthLocal.value = newValue;
  }
);

watch(
  () => props.selectedYear,
  (newValue) => {
    selectedYearLocal.value = newValue;
  }
);
</script>
